export default __webpack_public_path__ + "static/media/signup.bcd781a9.png";